module.exports = __webpack_public_path__ + "static/media/MarufResume.2c9ae320.pdf";